import React from 'react'
import { Grid, Paper, Typography, Box } from '@mui/material'
import logo from '../images/AGWE.png'
import mdg from '../images/MDG.png'

const AboutUsPage = () => {
  const inspirationAndImpact = (
    <Grid item xs={6}>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            variant='h7'
            component='div'
            style={{
              fontSize: 'xx-large',
              textAlign: '-webkit-right',
              width: '70%',
              fontFamily: 'sans-serif'
            }}
          >
            <strong>{'INSPIRATION AND IMPACT'}</strong>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper
            style={{
              padding: '5%',
              marginLeft: '50px',
              marginRight: '50px',
              marginTop: '1vh',
              backgroundColor: '#e2cfc5',
              borderRadius: '10%',
              height: '85vh'
            }}
          >
            <Typography
              variant='h7'
              component='div'
              style={{
                fontSize: 'xx-large',
                textAlign: 'justify',
                fontFamily: 'sans-serif',
                paddingBottom: '9vh'
              }}
            >
              {
                'A.G.W.E. is named in honor of the God of Water from Philippine Mythology.'
              }
            </Typography>
            <Typography
              variant='h7'
              component='div'
              style={{
                fontSize: 'xx-large',
                textAlign: 'justify',
                fontFamily: 'sans-serif',
                paddingBottom: '9vh'
              }}
            >
              {
                'This risk assessment tool is targeting the local government units (LGUs), fisherfolks, policymakers and other stakeholders. '
              }
            </Typography>
            <Typography
              variant='h7'
              component='div'
              style={{
                fontSize: 'xx-large',
                textAlign: 'justify',
                fontFamily: 'sans-serif',
                paddingBottom: '2vh'
              }}
            >
              {
                'Lastly, it aims to contribute to the following UN Sustainable Development Goals:'
              }
            </Typography>

            {<img src={mdg} alt='' width='740vw' height='400vh'></img>}
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )

  const aboutUs = (
    <>
      <Grid item xs={6} style={{ maxWidth: '50%' }}>
        <Grid item xs={12}>
          <Box sx={1} />
          <Typography
            variant='h5'
            component='div'
            style={{
              fontSize: 'xx-large',
              textAlign: 'start',
              width: '70%',
              fontFamily: 'sans-serif'
            }}
          >
            <strong>ABOUT US</strong>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper
            style={{
              padding: '5%',
              marginLeft: '50px',
              marginRight: '50px',
              marginTop: '1vh',
              backgroundColor: '#e2cfc5',
              borderRadius: '10%'
            }}
          >
            <Grid container>
              <Grid item xs={6}>
                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    fontSize: 'xx-large',
                    textAlign: 'justify',
                    width: '100%',
                    fontFamily: 'sans-serif'
                  }}
                >
                  <strong>
                    {
                      'Assessing Algal Growth in Water Eutrophication (A. G. W. E.)'
                    }
                  </strong>

                  {
                    ' is a risk-assessment tool to monitor and prevent Harmful Algal Blooms (HABs) in targeted areas using NASA’s space data. '
                  }
                </Typography>
                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    fontSize: 'xx-large',
                    textAlign: 'justify',
                    width: '100%',
                    fontFamily: 'sans-serif',
                    marginTop: '4vh'
                  }}
                >
                  {'It was created during the NASA Space App Challenge 2021. '}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ textAlignLast: 'end' }}>
                {<img src={logo} alt='' width='400vw' height='400vh'></img>}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Box sx={1} />
          <Typography
            variant='h7'
            component='div'
            style={{
              fontSize: 'xx-large',
              textAlign: 'start',
              width: '100%',
              fontFamily: 'sans-serif',
              marginTop: '1vh'
            }}
          >
            <strong>THE TEAM</strong>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper
            style={{
              padding: '5%',
              marginLeft: '50px',
              marginRight: '50px',
              marginTop: '1vh',
              backgroundColor: '#e2cfc5',
              borderRadius: '7%'
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    fontSize: 'xx-large',
                    textAlign: 'justify',
                    width: '100%',
                    fontFamily: 'sans-serif'
                  }}
                >
                  <strong>{'Data Analysis:'}</strong>
                </Typography>
                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    fontSize: 'xx-large',
                    textAlign: 'justify',
                    width: '100%',
                    fontFamily: 'sans-serif'
                  }}
                >
                  {
                    'Marvic Jon C. Alcantara, Ronald John O. Cabatic, Marc Edzel G. Danao, and  Julie Ann G. Delda'
                  }
                </Typography>
                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    fontSize: 'xx-large',
                    textAlign: 'justify',
                    width: '100%',
                    fontFamily: 'sans-serif',
                    marginTop: '4vh'
                  }}
                >
                  <strong>{'Web and Resources Design:'}</strong>
                </Typography>

                <Typography
                  variant='h7'
                  component='div'
                  style={{
                    fontSize: 'xx-large',
                    textAlign: 'justify',
                    width: '100%',
                    fontFamily: 'sans-serif'
                  }}
                >
                  {'Kirchelle Ann Mae E. Nodado and Alphagen V. Pajo '}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  )

  return (
    <>
      <Grid container spacing={1} style={{ margin: '10px' }}>
        {aboutUs}
        {inspirationAndImpact}
      </Grid>
    </>
  )
}

export default AboutUsPage
